import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { EmotionTheme } from 'src/domains/layouts/state/environmentState/EnvironmentState';
import { withConfig } from 'src/withConfig';


const setEventHeaderCaption = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            margin-right: 4px;
            width: 48px;
            flex: 0 0 48px;
            @media ${theme.star.mediaQuery.tablet} {
                width: 64px;
                flex: 0 0 64px;
            }
        `;
    }
    return css`
        width: 50px;
        flex: 0 0 50px;
        @media ${theme.star.mediaQuery.tablet} {
            flex-basis: 68px;
            width: 68px;
        }
    `;
};

interface EventHeaderCaptionPropsType {
    variant: DefaultComponentVariantType | null;
}

export const EventHeaderCaption = withConfig(theme => styled('div', { label: 'EventHeaderCaption' })<EventHeaderCaptionPropsType>`
    ${({ variant }): SerializedStyles => setEventHeaderCaption(variant, theme)}
    align-items: center;
    color: ${theme.star.collapse.competitionAndMarket.txtColor};
    display: flex;
    font-size: ${theme.star.fontSize.xSmall};
    font-weight: ${theme.star.fontWeight.xMedium};
    justify-content: center;
    line-height: 1.2;
    padding: ${theme.star.padding.medium};
`);

export const EventHeaderCaptionName = withConfig(theme => styled('span', { label: 'EventHeaderCaptionName' })`
    color: currentcolor;
    &:last-of-type {
        display: none;
    }
    @media ${theme.star.mediaQuery.tablet} {
        &:first-of-type {
            display: none;
        }
        &:last-of-type {
            display: block;
        }
    }
`);
